import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorkReportMeasuresApi from '@/services/apiServiceModules/workReportMeasuresApi'
const workReportMeasuresApi = new WorkReportMeasuresApi()

export default class WorkReportMeasuresDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORK_REPORT_MEASURES, workReportMeasuresApi, {
            useCache: true,
        })
	}
}
